import React from "react";
import Helmet from "react-helmet";

import HalfScreenParallaxHero from "../components/HalfScreenParallaxHero";
import ParallaxDivider from "../components/ParallaxDivider";
import ProjectThumbnail from "../components/ProjectThumbnail";
import NextPageSection from "../components/NextPageSection";

class portfolioPage extends React.Component {
  render() {
    const dataql = this.props.data;
    const acf = this.props.data.wordpressPage.acf;
    const posts = this.props.data.allWordpressWpMbProject.edges;

    console.log(posts.map(a => a.node.tags));

    return (
      <div className="wow fadeIn" style={{ visibility: "hidden" }}>
        <Helmet title="Portfolio | Moon Beyond Co" />
        <div>
          {/* head section */}
          <HalfScreenParallaxHero
            title={acf.title}
            bg={acf.background_image.localFile.childImageSharp.resolutions.src}
            symbol={acf.symbol.localFile.childImageSharp.sizes.src}
          />
          {/* end head section */}
          {/* portfolio section */}
          <div className="work-3col gutter no-margin-top content-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center">
                  <div className>
                    {/* work filter */}
                    {/* <ul className="portfolio-filter nav nav-tabs nav-tabs-light animated fadeInUp">
                      <li className="nav active">
                        <a href="#" data-filter="*">
                          All
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".web">
                          Web Design/Development
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".branding">
                          Branding
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".copywriting">
                          Copywriting
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".social">
                          Social Media
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".packaging">
                          Packaging
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".multimedia">
                          Multimedia
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".marketing">
                          Marketing
                        </a>
                      </li>
                      <li className="nav">
                        <a href="#" data-filter=".print">
                          Print
                        </a>
                      </li>
                    </ul> */}
                    {/* end work filter */}
                  </div>
                </div>
                <div className="col-md-12 grid-gallery overflow-hidden">
                  <div className="tab-content">
                    {/* Portfolio grid */}
                    <ul className="grid masonry-items">
                      {posts
                        .sort((a, b) => (a.node.menu_order > b.node.menu_order ? 1 : -1))
                        .map((a, i) => (
                          <ProjectThumbnail
                            key={i}
                            name={a.node.acf.project_title}
                            tags={a.node.tags ? a.node.tags.map(tag => tag.name) : [""]}
                            link={a.node.slug}
                            tagMap={this.props.data.allWordpressTag.edges}
                            hoverImg={dataql.thumbBG}
                            BG={a.node.acf.thumbnail && a.node.acf.thumbnail.localFile.childImageSharp}
                          />
                        ))}
                    </ul>
                    {/* end Portfolio grid */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end portfolio section */}
          {/* new project */}
          <section className="new-project no-padding-top">
            <div className="container">
              <div className="row center-col text-center wow fadeInUp">
                <NextPageSection blurb={acf.next_page_blurb} to="contact" linkText={acf.next_page_button_text} black />
              </div>
            </div>
          </section>
          {/* end new project */}
        </div>
      </div>
    );
  }
}

export default portfolioPage;

export const query = graphql`
  query portfolioPageQuery {
    wordpressPage(title: { eq: "Portfolio" }) {
      acf {
        next_page_blurb
        next_page_button_text
        next_page_link
        contact_subtitle
        title
        background_image {
          localFile {
            childImageSharp {
              ...HeaderBG
            }
          }
        }
        symbol {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                src
              }
            }
          }
        }
      }
    }

    allWordpressWpMbProject {
      edges {
        node {
          slug
          tags {
            name
          }
          menu_order
          acf {
            thumbnail {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 375, maxHeight: 233, quality: 90, toFormat: JPG) {
                    ...GatsbyImageSharpSizes_withWebp
                  }
                }
              }
            }
            project_title
          }
        }
      }
    }

    allWordpressTag {
      edges {
        node {
          wordpress_id
          name
        }
      }
    }

    headerBG: imageSharp(id: { regex: "/mb/portfolio_header.png/" }) {
      ...HeaderBG
    }

    thumbBG: imageSharp(id: { regex: "/mb/projectThumbBG.jpg/" }) {
      resolutions(width: 375, height: 233, quality: 90, toFormat: JPG) {
        ...GatsbyImageSharpResolutions_withWebp
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/portfolio.js